import ColorSwatchIcon from './ColorSwatchIcon';

export default ColorSwatchIcon;
